import React from 'react'
import style from './style.module.css'
import { Services1 } from '../../assets'

export const ServicesCard = ({
  image = Services1,
  header = 'Efficient and Quality Tax Collection and Management',
  description = ''
}) => {
  return (
    <div className={style.services__card}>
      <div className={style.services__card_image}>
        <img src={image} alt='Service' />
      </div>
      <div>
        <h4>{header}</h4>
        <p>{description}</p>
      </div>
    </div>
  )
}

export const TeamCard = ({
  image = Services1,
  header = '',
  description = ''
}) => {
  return (
    <div className={style.team__card}>
      <div className={style.team__card_image}>
        <img src={image} alt='Team' />
      </div>
      <div>
        <p className={style.description}>{header}</p>
        <p>{description}</p>
      </div>
    </div>
  )
}

export const ContactCard = ({
  Icon = null,
  header = '',
  description = ''
}) => {
  return (
    <div className={style.contact__card}>
      <div className={style.contact__card_image}>
        {Icon && <Icon />}
      </div>
      <div className={style.contact__card_description}>
        <p>{header}</p>
        <p>{description}</p>
      </div>
    </div>
  )
}

